module.exports = __webpack_public_path__ + "static/media/img_0.4ffb538b.png";